import React from 'react';
import { connect } from 'react-redux';
import { compose, withHandlers, lifecycle, withState } from 'recompose';
import PropTypes from 'prop-types';

import { Field, reduxForm } from 'redux-form';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import { forgottenPasswordRequest, loginReset } from '../../redux/reducers/login';
import EmailField from './EmailField';
import { validateForgottenPassword } from './validate';

import { commonStyles } from '../../styles/styles';

const ForgottenPasswordForm = ({
  classes,
  handleSubmit,
  submitting,
  handleSubmitForgottenPassword,
  showSuccess,
  loginReducer,
}) => (
  <form onSubmit={handleSubmit(handleSubmitForgottenPassword)} className={classes.form}>
    {loginReducer.error && (
      <Typography className={classes.formError}>
        {loginReducer.error.response.data.message}
      </Typography>
    )}
    {!loginReducer.error &&
      showSuccess && (
        <Typography className={classes.formSuccess}>
          Reset password request was sent. Please check your email
        </Typography>
      )}
    <Field name="Email" component={EmailField} />
    <Button
      variant="contained"
      type="submit"
      disabled={submitting}
      className={`${classes.defaultButton} ${classes.shortButton}`}
    >
      RESET PASSWORD
    </Button>
  </form>
);
ForgottenPasswordForm.propTypes = {
  classes: PropTypes.instanceOf(Object),
  loginReducer: PropTypes.instanceOf(Object),
  submitting: PropTypes.bool,
  showSuccess: PropTypes.bool,
  handleSubmit: PropTypes.func,
  handleSubmitForgottenPassword: PropTypes.func,
};

const mapStateToProps = state => ({
  form: state.form,
  loginReducer: state.loginReducer,
});

const mapDispatchToProps = dispatch => ({
  forgottenPasswordRequest: () => dispatch(forgottenPasswordRequest()),
  loginReset: () => dispatch(loginReset()),
});

const styles = () => ({
  ...commonStyles,
  form: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: 10,
  },
});

export default compose(
  reduxForm({
    form: 'forgottenPassword',
  }),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('showSuccess', 'handleSuccessMessage', null),
  withHandlers({
    handleSubmitForgottenPassword: props => values => {
      validateForgottenPassword(values);
      props.forgottenPasswordRequest();
    },
  }),
  lifecycle({
    componentWillReceiveProps(nextProps) {
      const { loginReducer, loginReset, handleSuccessMessage } = nextProps;
      const { responseForgottenPassword } = this.props.loginReducer;
      if (loginReducer.fetchingForgottenPassword) {
        loginReset();
      }
      if (loginReducer.responseForgottenPassword !== responseForgottenPassword) {
        handleSuccessMessage(true);
      }
    },
    componentWillUnmount() {
      if (this.props.loginReducer.error) {
        this.props.loginReset();
      }
    },
  }),
  withStyles(styles),
)(ForgottenPasswordForm);



// WEBPACK FOOTER //
// ./src/Components/Form/ForgottenPasswordForm.jsx